import React from 'react';

import { BlockWrapper, defineBlock, smartProps, useInspectorControl } from '@smartfire/js-block-engine';
import Header from './Header';

const InspectorLazy = React.lazy(() => import('./Inspector'));

function Block({ menuButtons, socials, menu, translatedLinks }) {
    useInspectorControl(InspectorLazy, []);

    return (
        <BlockWrapper.Header>
            <Header menu={menu} menuButtons={menuButtons} socials={socials} translatedLinks={translatedLinks} />
        </BlockWrapper.Header>
    );
}

export default defineBlock({
    Block: Block as React.FC<unknown>,
    smartProps: {
        buttonText1: smartProps.string.withDefault('boutique'),
        buttonText2: smartProps.string.withDefault('billetterie'),
        buttonLink1: smartProps.string.withDefault(''),
        buttonLink2: smartProps.string.withDefault(''),
        type1: smartProps.bool.withDefault(false), //false: link - true: file
        type2: smartProps.bool.withDefault(false), //false: link - true: file
        file1: smartProps.object.withDefault(null),
        file2: smartProps.object.withDefault(null),
        external1: smartProps.bool.withDefault(false),
        external2: smartProps.bool.withDefault(false),
        menu: smartProps.array.withDefault([]),
    },
    setup: {
        title: 'Navbar',
    },
});
